import { BlockSectionMargin } from './BlockSectionMargin.csharp';

export class BlockSectionClassResolver {
    public static Resolve(margin: BlockSectionMargin): string {
        return `BlockSection--${BlockSectionMargin[margin]}`;
    }
}
